import { RefObject } from 'react';

export const onNextClicked = (containerRef: RefObject<HTMLDivElement | null>, offset = 0): void => {
  const { current } = containerRef;
  if (current) {
    const containerRightEdge = current.getBoundingClientRect().right;
    const firstOffscreenChild = [...current.children].find(child => {
      return child.getBoundingClientRect().right > containerRightEdge + offset;
    });
    if (firstOffscreenChild) {
      firstOffscreenChild.scrollIntoView({
        block: 'nearest',
        inline: 'start',
        behavior: 'smooth',
      });
    }
  }
};

export const onPreviousClicked = (
  containerRef: RefObject<HTMLDivElement | null>,
  offset = 0,
): void => {
  const { current } = containerRef;
  if (current) {
    const containerLeftEdge = current.getBoundingClientRect().left;
    const lastOffscreenChild = [...current.children].reverse().find(child => {
      return child.getBoundingClientRect().left < containerLeftEdge - offset;
    });
    if (lastOffscreenChild) {
      lastOffscreenChild.scrollIntoView({ block: 'nearest', inline: 'end', behavior: 'smooth' });
    }
  }
};
